import TrashCan from '../../src/legacy/TrashCan';
export default TrashCan;
